import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

export const convertToLocalRelativeTime = (utcTime: string) => {
  if (!utcTime) return 'now';

  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const now = dayjs.utc().tz(localTimeZone);
  const targetTime = dayjs.utc(utcTime).tz(localTimeZone);
  const diffInSeconds = now.diff(targetTime, 'second');

  const timeIntervals = [
    { unit: 'now', limit: 60 }, // 0 ~ 59 seconds
    { unit: 'min', limit: 3600, divisor: 60 }, // 1min ~ 59min
    { unit: 'h', limit: 86400, divisor: 3600 }, // 1h ~ 23h
    { unit: 'd', limit: 604800, divisor: 86400 }, // 1d ~ 6d
    { unit: 'w', limit: 2419200, divisor: 604800 }, // 1w ~ 4w
    { unit: 'mo', limit: 31536000, divisor: 2419200 }, // 1mo ~ 11mo
    { unit: 'y', limit: Infinity, divisor: 31536000 }, // 1y ~
  ];

  for (const interval of timeIntervals) {
    if (diffInSeconds < interval.limit) {
      if (interval.unit === 'now') {
        return 'now';
      }
      return `${Math.floor(diffInSeconds / (interval.divisor || 1))}${
        interval.unit
      }`;
    }
  }
};
